package app.footyguide.web.components

import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.*

fun formatChannelName(channel: String): String {
    val clean = channel.trim().lowercase()
    return when {
        clean == "globo" || clean == "tv-globo" -> "GLOBO"
        clean == "premiere" -> "PREMIERE"
        clean == "sportv" || clean == "sportv2" || clean == "sportv3" -> "SPORTV"
        clean == "cazetv" || clean == "caze-tv" || clean == "caze" -> "CAZÉTV"
        clean == "prime" || clean == "primevideo" || clean == "prime-video" -> "PRIME VIDEO"
        clean == "espn" || clean == "espn2" || clean == "espn4" -> "ESPN"
        clean == "disney" || clean == "disney+" || clean == "disneyplus" -> "DISNEY+"
        clean == "paramount" || clean == "paramount+" -> "PARAMOUNT+"
        clean == "record" -> "RECORD"
        clean == "sbt" -> "SBT"
        clean == "band" || clean == "bandsports" -> "BAND"
        clean == "youtube" -> "YOUTUBE"
        else -> channel.trim().uppercase()
    }
}

@Composable
fun ChannelBadgesRow(
    channels: List<String>,
    maxVisible: Int = 2,
    modifier: (() -> Unit)? = null
) {
    if (channels.isEmpty()) return
    var expanded by remember(channels) { mutableStateOf(false) }
    val visibleChannels = if (expanded) channels else channels.take(maxVisible)
    val remaining = channels.size - maxVisible

    Div({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            flexWrap(FlexWrap.Wrap)
            gap(6.px)
        }
    }) {
        visibleChannels.forEach { channelId ->
            val label = formatChannelName(channelId)
            Span({
                style {
                    property("display", "inline-flex")
                    alignItems(AlignItems.Center)
                    gap(4.px)
                    backgroundColor(Color("#F2F2EC"))
                    color(Color("#16181D"))
                    border(1.px, LineStyle.Solid, Color("var(--border)"))
                    borderRadius(6.px)
                    padding(3.px, 8.px)
                    fontFamily("Sora, 'Plus Jakarta Sans', sans-serif")
                    fontSize(10.px)
                    fontWeight(700)
                    letterSpacing(0.4.px)
                    property("line-height", "1")
                    property("white-space", "nowrap")
                }
            }) {
                LucideIcon(
                    name = Icons.TV,
                    size = 12,
                    color = "#5E636E"
                )
                Text(label)
            }
        }
        if (!expanded && remaining > 0) {
            Span({
                onClick { event ->
                    event.stopPropagation()
                    expanded = true
                }
                style {
                    property("display", "inline-flex")
                    alignItems(AlignItems.Center)
                    fontFamily("Sora, 'Plus Jakarta Sans', sans-serif")
                    fontSize(10.px)
                    fontWeight(800)
                    color(Color("#16181D"))
                    backgroundColor(Color("#E7E7E1"))
                    borderRadius(6.px)
                    padding(3.px, 7.px)
                    cursor("pointer")
                    property("line-height", "1")
                }
            }) {
                Text("+$remaining")
            }
        }
    }
}
